import { LAYOUT_SET_PREVIOUS_URL_REQUEST } from './constants';

export const setPreviousUrl = (url) => ({
  type: LAYOUT_SET_PREVIOUS_URL_REQUEST,
  url
});
